<template>
  <div>
    <div class="main-title">代金券列表</div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-button type="primary" @click="addCoupon">购买代金券</el-button>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.datefield"
              @change="search(searchParams)"
              style="width:120px">
              <el-option label="领券日期" value="coupon_time"></el-option>
              <el-option label="使用日期" value="use_time"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="searchForm.daterange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="datePickerOptions"
              @change="search(searchParams)">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索代金券编号"
              v-model="searchForm.query"
              prefix-icon="el-icon-search"
              clearable
              @input="inputSearch(searchParams)">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.status"
              @change="search(searchParams)"
              style="width:120px">
              <el-option label="全部" value="全部"></el-option>
              <el-option label="未使用" value="未使用"></el-option>
              <el-option label="已使用" value="已使用"></el-option>
              <el-option label="已折现" value="已折现"></el-option>
              <el-option label="已过期" value="已过期"></el-option>
              <el-option label="已作废" value="已作废"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索备注"
              v-model="searchForm.remark"
              prefix-icon="el-icon-search"
              clearable
              @input="inputSearch(searchParams)">
            </el-input>
          </el-form-item>
        </el-form>
        <el-button-group>
          <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
          <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
          <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
        </el-button-group>
      </div>
      <el-table
        ref="table"
        :data="list"
        stripe
        border
        :height="tableHeight"
        :summary-method="getSummaries"
        show-summary
        :row-class-name="tableRowClassName"
        style="width:100%">
        <el-table-column
          prop="id"
          label="系统编号"
          fixed
          width="80">
        </el-table-column>
        <el-table-column
          prop="coupon_no"
          label="代金券编号"
          fixed
          width="180">
        </el-table-column>
        <el-table-column
          prop="coupon_money"
          label="金额"
          fixed
          width="60">
        </el-table-column>
        <el-table-column
          prop="coupon_owner"
          label="拥有者"
          width="100">
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          width="80"
          :filters="statusFilters"
          :filter-method="filterStatus"
          filter-placement="bottom-end">
        </el-table-column>
        <el-table-column
          prop="resource"
          label="来源"
          width="120">
        </el-table-column>
        <el-table-column
          prop="licnum"
          label="车牌号"
          width="120">
        </el-table-column>
        <el-table-column
          prop="coach_name"
          label="教练"
          width="180">
        </el-table-column>
        <el-table-column
          prop="oper_name"
          label="操作员"
          width="70">
        </el-table-column>
        <el-table-column
          prop="coupon_time"
          label="领券时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="use_time"
          label="使用时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          width="260">
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="120">
          <template slot-scope="scope">
            <el-button type="text" v-if="scope.row.use_time" @click="billDetail(scope.row.bill_id)">账单详情</el-button>
            <el-button type="text" v-if="scope.row.status === '未使用' && [1,10].indexOf(user.group_id) >= 0" @click="refund(scope.row)">退款</el-button>
            <el-button type="text" v-if="scope.row.status === '未使用'" @click="zhexian(scope.row)">折现</el-button>
            <el-button type="text" v-if="scope.row.status === '未使用'" style="color:#f56c6c;" @click="invalid(scope.row)">作废</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-sizes="[minPageSize, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog title="购买代金券" :visible.sync="addFormVisible">
      <el-form :model="addForm" ref="addForm" :rules="addFormRules" label-width="200px">
        <el-form-item label="所属考场">
          <el-select v-model="addForm.company_id">
            <el-option v-for="item in companyList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="coupon_no" label="代金券编号">
          <el-input v-model="addForm.coupon_no" style="width:194px;" placeholder="建议使用学员身份证"></el-input>
        </el-form-item>
        <el-form-item prop="coupon_owner" label="学员姓名">
          <el-input v-model="addForm.coupon_owner" style="width:100px;"></el-input>
        </el-form-item>
        <el-form-item prop="coupon_money" label="金额">
          <el-input v-model.number="addForm.coupon_money" style="width:100px;"></el-input>
        </el-form-item>
        <el-form-item label="支付方式" prop="pay_type">
          <el-col :span="11">
            <el-select v-model="addForm.pay_type" placeholder="请选择支付方式" @change="payTypeChange" style="width:100%">
              <el-option label="现金" value="现金"></el-option>
              <el-option label="支付宝" value="支付宝"></el-option>
              <el-option label="微信支付" value="微信支付"></el-option>
              <el-option label="刷卡" value="刷卡"></el-option>
              <el-option label="转账" value="转账"></el-option>
            </el-select>
          </el-col>
          <el-col :span="2" style="text-align:center;">-</el-col>
          <el-col :span="11">
            <el-form-item prop="fin_account">
              <el-select v-model="addForm.fin_account" placeholder="请选择账户" style="width:100%">
                <el-option v-for="i in accountListFilter" :key="i.id" :label="i.name" :value="i.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="addForm.remark" type="textarea" autosize placeholder="备注(可以不填)"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addFormCommit" :loading="addFormCommiting">确 定</el-button>
        <el-button @click="addFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 账单详情窗口 -->
    <bill-dialog :visible="billDialogVisible" :bill-id="billId" @close="billDialogVisible = false"></bill-dialog>
  </div>
</template>

<script>
import BillDialog from '../rent/BillDialog'
import ListFunc from '../../mixins/ListFunc'
import DatePickerOptions from '../../mixins/DatePickerOptions'
import moment from 'moment'
export default {
  mixins: [ListFunc, DatePickerOptions],
  props: {
    user: Object
  },
  components: {
    BillDialog
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.table.doLayout();
    });
  },
  data () {
    return {
      sqlcode: 'coupon_list',
      searchForm: {
        query: '',
        datefield: 'coupon_time',
        daterange: [],
        status: '全部',
        remark: ''
      },
      statusFilters: [
        { text: '未使用', value: '未使用' },
        { text: '已使用', value: '已使用' },
        { text: '已折现', value: '已折现' },
        { text: '已过期', value: '已过期' },
        { text: '已作废', value: '已作废' }
      ],
      addForm: {
        coupon_no: '',
        coupon_owner: '',
        coupon_money: 200,
        company_id: 0,
        fin_type: '1',
        fin_item: '购买代金券',
        pay_type: '现金',
        fin_account: 0,
        remark: ''
      },
      addFormRules: {
        coupon_no: [
          { required: true, message: "请输入代金券编号", trigger: "blur" }
        ],
        coupon_owner: [
          { required: true, message: "请输入学员姓名", trigger: "blur" }
        ],
        coupon_money: [
          { required: true, message: "请输入代金券金额", trigger: "blur" }
        ]
      },
      addFormVisible: false,
      addFormCommiting: false,
      companyList: [],
      billDialogVisible: false,
      accountList: [],
      billId: 0
    }
  },
  computed: {
    searchParams () {
      if (!this.searchForm.daterange || this.searchForm.daterange.length === 0) {
        return this.searchForm
      } else {
        if (this.searchForm.datefield === 'coupon_time') {
          return {
            query: this.searchForm.query,
            status: this.searchForm.status,
            coupon_time_start: moment(this.searchForm.daterange[0]).format('YYYY-MM-DD'),
            coupon_time_end: moment(this.searchForm.daterange[1]).format('YYYY-MM-DD') + ' 23:59:59',
            remark: this.searchForm.remark
          }
        } else {
          return {
            query: this.searchForm.query,
            status: this.searchForm.status,
            use_time_start: moment(this.searchForm.daterange[0]).format('YYYY-MM-DD'),
            use_time_end: moment(this.searchForm.daterange[1]).format('YYYY-MM-DD') + ' 23:59:59',
            remark: this.searchForm.remark
          }
        }
      }
    },
    accountListFilter () {
      if (this.addForm.pay_type === '现金') {
        return this.accountList.filter(i => i.account_type === '现金')
      } else if (this.addForm.pay_type === '支付宝') {
        return this.accountList.filter(i => i.account_type === '支付宝')
      } else if (this.addForm.pay_type === '微信支付') {
        return this.accountList.filter(i => i.account_type === '微信')
      } else if (this.addForm.pay_type === '刷卡') {
        return this.accountList.filter(i => i.account_type === '银行')
      } else if (this.addForm.pay_type === '转账') {
        return this.accountList.filter(i => i.account_type === '银行')
      } else {
        return []
      }
    }
  },
  mounted () {
    this.fetchCompanyList()
    this.fetchAccountList()
  },
  methods: {
    filterStatus (value, row) {
      return row.status ===  value
    },
    tableRowClassName({row, rowIndex}) {
      if (row.status === '未使用') {
        return ''
      } else if (row.status === '已使用') {
        return 'row-green'
      } else {
        return 'row-red'
      }
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        const values = data.map(item => Number(item[column.property]))
        if (column.property === 'coupon_money') {
          let i = -1
          sums[index] = values.reduce((prev, curr) => {
            i++
            const value = Number(curr)
            if (!isNaN(value) && data[i].status !== '已作废') {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else if (column.property === 'coupon_no') {
          sums[index] = '合计'
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    billDetail (bill_id) {
      this.billId = bill_id
      this.billDialogVisible = true
    },
    fetchCompanyList () { // 获取考场列表
      this.$http.get('/dbapi/company_combo').then(response => {
        if (response.data.success) {
          this.companyList = response.data.list
          if (this.companyList.length > 0) {
            this.addForm.company_id = this.companyList[0].value
          }
        }
      })
    },
    fetchAccountList () {
      this.$http.get('/dbapi/fin_account_combo').then(response => {
        if (response.data.success) {
          this.accountList = response.data.list
          if (this.accountList.length > 0) {
            this.addForm.fin_account = this.accountList[0].id
          }
        }
      })
    },
    payTypeChange () {
      if (this.accountListFilter.length > 0) {
        this.addForm.fin_account = this.accountListFilter[0].id
      }
    },
    addCoupon () {
      this.addFormVisible = true
    },
    addFormCommit () { // 购买代金券
      this.$refs.addForm.validate(valid => {
        if (valid) {
          if (!/\w/.test(this.addForm.coupon_no)) {
            this.$alert('编号只能是字母或数字', 'xx错误xx', {
              confirmButtonText: '我知道了'
            })
            return
          }
          this.addFormCommiting = true
          this.$http.get('/dbapi/coupon_unused?coupon_no=' + this.addForm.coupon_no).then(response => {
            if (response.data.success) {
              if (response.data.list.length > 0) {
                return Promise.reject('该代金券编号重复,请检查')
              }
              return this.$http.post('/dbapi/insert_coupon', this.addForm)
            } else {
              return Promise.reject(response.data.message)
            }
          }).then(response => {
            this.addFormCommiting = false
            if (response.data.success) {
              this.$refs.addForm.resetFields()
              this.addFormVisible = false
              this.refresh()
              this.$message({
                type: 'success',
                message: '代金券添加成功'
              })
              this.$confirm('是否要现在打印收据?', '提示', {
                confirmButtonText: '现在打印',
                cancelButtonText: '稍后打印',
                type: 'warning'
              }).then(() => {
                window.open(this.$http.receiptBaseUrl + '/fin_print?ids=' + response.data.insertId + '&token=' + localStorage.getItem('kaochang.token'))
              })
            } else {
              return Promise.reject(response.data.message)
            }
          }).catch(msg => {
            this.addFormCommiting = false
            this.$message({
              type: 'error',
              message: msg
            })
          })
        }
      })
    },
    zhexian (row) {
      this.$prompt('请输入折现备注', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        this.$http.post('/dbapi/coupon_zhexian', {
          id: row.id,
          remark: value
        }).then(response => {
          if (response.data.success) {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            this.refresh()
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            })
          }
        })
      })
    },
    invalid (row) {
      this.$prompt(`请输入作废原因`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        this.$http.post('/dbapi/invalid_coupon', {
          id: row.id,
          remark: value
        }).then(response => {
          if (response.data.success) {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            this.refresh()
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            })
          }
        })
      })
    },
    refund (row) {
      this.$prompt('请输入退款金额', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: 100
      }).then(({ value }) => {
        this.$http.post('/dbapi/coupon_refund', {
          id: row.id,
          refund_money: parseInt(value) || 100
        }).then(response => {
          if (response.data.success) {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            this.refresh()
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            })
          }
        })
      })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/card/Coupon.vue